const API_BASE = import.meta.env.VITE_API_URL || 'https://ekyc.tumkurconnect.com/api/v1';

/**
 * Convert a relative file path (stored in DB) to an authenticated API URL.
 * Falls back to the original value if it is already a full URL or empty.
 */
export function getFileUrl(filePath: string | null | undefined): string {
  if (!filePath) return '';
  if (filePath.startsWith('http')) return filePath;
  return `${API_BASE}/files/${filePath}`;
}